import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import LayoutComponent from "./LayoutComponent";
import routes from "./routes";
import PublicRoute from "./PublicRoute";
import { CompanyProvider } from "../contexts/CompanyContext";

const Routers: React.FC = () => {
  return (
    <Router>
      <CompanyProvider>
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <LayoutComponent layoutType={route.layoutType}>
                  {route.isPrivate ? (
                    <PrivateRoute path={route.path} element={route.element} />
                  ) : (
                    <PublicRoute path={route.path} element={route.element} />
                  )}
                </LayoutComponent>
              }
            />
          ))}
        </Routes>
      </CompanyProvider>
    </Router>
  );
};

export default Routers;
